import BaseHttpService from './base-http.service';

export default class BillingService extends BaseHttpService {
  fetchBills() {
    return this.get('stripe/get/bills');
  }

}
